import template from './template.pug';

const responsiveAdThumbnailWidth = 114;
const responsiveAdThumbnailHeight = 60;
const resizeQueryString = `&w=${responsiveAdThumbnailWidth}&h=${responsiveAdThumbnailHeight}`;

const responsiveAdPreviewTemplate = function ({
  itemViewModel, i18n, withContainer, isMMAV2Enabled,
}) {
  const { isVideo } = itemViewModel;

  // if we find originalImageUrlToUse, then it means this image is from V2 and we will use original image URL for preview.
  let imageUrlToUse = isMMAV2Enabled && itemViewModel.OriginalImageMediaUrl ? itemViewModel.OriginalImageMediaUrl : itemViewModel.LandscapeImageMediaUrl;

  if (imageUrlToUse && !isVideo) {
    // strip off the resizing from MT as we need a smaller resizing
    const indexOfResizeInfo = imageUrlToUse.indexOf('&w=');
    if (indexOfResizeInfo > 0) {
      imageUrlToUse = imageUrlToUse.substr(0, indexOfResizeInfo);
    }

    itemViewModel.LandscapeImageMediaUrl = `${imageUrlToUse}${resizeQueryString}`; // eslint-disable-line
  }

  return template({ itemViewModel, i18n, withContainer });
};

export { responsiveAdPreviewTemplate };
